import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import { HeaderH2, HeaderH1, Text, NextButton, ImageBlock, HeaderH3 } from "components/TextBlocks";

const SC = ({ ...props }) => {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return <span style={keyCss}>{props.children}</span>;
};

function Bin(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Bin</HeaderH1>
      <Text>
        {" "}
        The bin stores up to 50 of your most recently deleted items(Groups, sites, side-by-side
        stacks, and notes). From the bin modal you can restore selected item you want back.
      </Text>
      <ImageBlock src={"/guide/bin.png"} width={662} height={446} alt={"Bin modal"} />
      <Text>
        It can be opened with the actions menu in the right hand corner, or with the shortcut:{" "}
        <SC>Ctrl</SC> + <SC>Z</SC> (can be changed in shortcut settings).
      </Text>
      <ImageBlock
        src={"/guide/restored_group.png"}
        width={456}
        height={260}
        alt={"Restored group"}
      />
      <Text>
        If the restored items are notes or sites they will be placed in a group called "Restored
        items" like above.
      </Text>
    </>
  );
}

Bin.Layout = SideBar;

export default Bin;
